import React from "react";
import first from "lodash/first";
import { set } from "object-path-immutable";
import DisplayComponent from "./DisplayComponent";
import { getPlace } from "util/lifterHelper";
import { Attempt, Lifter, Meet } from "types";
import { WidgetId, useDisplaySettings } from "./DisplaySettingsProvider";

const getGetOrdinal = (n: number | null) => {
  if (!n) {
    return null;
  }
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const positionChangeText = ({
  currentPlace,
  possiblePlace,
}: {
  currentPlace?: number | null;
  possiblePlace?: number | null;
}) => {
  if (!currentPlace || !possiblePlace) {
    return "";
  } else if (currentPlace === possiblePlace) {
    return `If successful will stay in ${getGetOrdinal(possiblePlace)} place`;
  } else if (currentPlace && possiblePlace) {
    return `If successful will move from ${getGetOrdinal(
      currentPlace,
    )} to ${getGetOrdinal(possiblePlace)} place`;
  }

  return null;
};

export const getPositionChange = ({
  meet,
  currentLifter,
  currentAttempt,
}: {
  meet: Meet;
  currentLifter: Lifter;
  currentAttempt: Attempt;
}) => {
  let currentPlace: number | null = 0;
  let possiblePlace: number | null = 0;

  if (currentAttempt.attemptNumber !== "3") {
    return "";
  }

  const firstDivision = first(currentLifter?.divisions ?? []);
  if (
    currentAttempt?.liftName &&
    currentAttempt?.attemptNumber &&
    currentLifter &&
    firstDivision
  ) {
    currentPlace = getPlace(currentLifter, firstDivision, meet);

    // construct version of meet where the current attempt is successful.
    const futureMeet = set(
      meet,
      [
        "lifters",
        currentLifter._id,
        "lifts",
        currentAttempt.liftName,
        currentAttempt.attemptNumber,
        "result",
      ],
      "good",
    );

    possiblePlace = getPlace(currentLifter, firstDivision, futureMeet);
  }
  return positionChangeText({ currentPlace, possiblePlace });
};

const PositionChange = ({
  id,
  meet,
  currentAttempt,
  currentLifter,
}: {
  id: WidgetId;
  meet: Meet;
  currentAttempt: Attempt | undefined;
  currentLifter: Lifter | undefined;
}) => {
  const { editMode } = useDisplaySettings();

  return (
    <DisplayComponent id={id} style={{ top: 170, left: 0 }}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style: React.CSSProperties = {
          fontSize: sizeMultiplier * 24,
          width: sizeMultiplier * 600,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          whiteSpace: "nowrap",
        };

        return (
          <div style={style}>
            {editMode ? (
              <>{positionChangeText({ currentPlace: 2, possiblePlace: 1 })}</>
            ) : (
              <>
                {!!currentAttempt && !!currentLifter && (
                  <>
                    {getPositionChange({ meet, currentAttempt, currentLifter })}
                  </>
                )}
              </>
            )}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default PositionChange;
